import { AppBar, Box, Dialog, DialogContent, Stack, Toolbar } from "@mui/material";
import { Theme } from "klayowebshared";
import { AppContext } from "../../common/AppContext";
import { Utils } from "../../common/Utils";
import { ErrorModel } from "../../common/models/ErrorModel";
import { Alert } from "../../components/Alert";
import { Button } from "../../components/Button";
import { ViewComponent } from "../../components/ViewComponent";
import { UpdateCreditCard } from "../../data/settings/UpdateCreditCard";
import { withLocale, WithLocaleProps } from "../../providers/LocaleProvider";
import CloseIcon from "../../resources/images/icons-close.svg";
import Logo from "../../resources/images/logo.svg";
import { CreditCardPayment } from "./CreditCardPayment";

interface CreditCardDetailsDialogProps extends WithLocaleProps {
  organization?: any;
  user?: any;
  onClose?: () => void;
  theme: typeof Theme;
}

class CreditCardDetailsDialogBase extends ViewComponent<CreditCardDetailsDialogProps> {
  static contextType = AppContext;

  constructor(props: any) {
    super(props);

    this.state = {
      error: null,
      submitting: false,
      submitted: false,
      creditCardDetails: null,
      creditCardAttemptId: 0,
      ewaySecureFieldCode: null
    };
  }

  onSubmit(e: any) {
    const { onClose } = this.props;
    const { ewaySecureFieldCode } = this.state;

    this.context?.setLoading?.("submitting", true);
    this.setState({ error: null, submitting: true });

    UpdateCreditCard.post(this.context, {
      securedFieldsCode: ewaySecureFieldCode
    })
      .then((n) => {
        this.setState({ error: null, submitted: true });
        onClose?.();
      })
      .catch((e) => {
        const error = ErrorModel.parseServerError(e);
        this.setState({ error, creditCardAttemptId: Utils.generateUniqueId() });
      })
      .finally(() => {
        this.context?.setLoading?.("submitting", false);
        this.setState({ submitting: false });
      });
  }

  setError(error: any) {
    this.setState({ error });
    if (error) window.scrollTo(0, 0);
  }

  onCreditCardChange(creditCardDetails: any, ewaySecureFieldCode: any) {
    this.setState({ creditCardDetails, ewaySecureFieldCode });
  }

  render() {
    const { organization, user, onClose, translate } = this.props;
    const { error, submitting, billingContact, billingDetails, creditCardAttemptId } = this.state;

    return (
      <Dialog className='klayo-billingplandialog' onClose={onClose} open={true} fullScreen={true}>
        <AppBar className='klaro_employeeprofile-appbar' elevation={0}>
          <Toolbar>
            <Logo className='klaro-appbar_logo' />
            <Box sx={{ flexGrow: 1 }}></Box>
            <Box sx={{ display: { xs: "none", md: "flex" } }}>
              <Button
                autoFocus
                label={translate("common.close")}
                variant='outlined'
                size='md'
                startIcon={<CloseIcon />}
                onClick={onClose}
              />
            </Box>
          </Toolbar>
        </AppBar>
        <DialogContent sx={{ marginTop: "64px", backgroundColor: "#F8F8FE" }}>
          <div className='klayo-billingplandialog_content'>
            <Stack direction='column' spacing={4}>
              {error && (
                <Alert severity='error' scrollTo={true}>
                  {error}
                </Alert>
              )}

              <CreditCardPayment
                onChange={this.onCreditCardChange.bind(this)}
                visible={true}
                attemptId={creditCardAttemptId}
              />

              <div style={{ textAlign: "center", padding: "30px" }}>
                <Button
                  label={translate("billing.saveDetails")}
                  variant='filled'
                  onClick={this.onSubmit.bind(this)}
                  disabled={submitting}
                />
              </div>
            </Stack>
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}

export const CreditCardDetailsDialog = withLocale(CreditCardDetailsDialogBase);
